(ns quuppa.qsm.metadata.view
  (:require [quuppa.ui.form :as form]
            [quuppa.ui.layout :as layout]
            [quuppa.ui.dropdown :as dropdown]
            [quuppa.qsm.metadata.events]))

(defn metadata-sidebar [initial-metadata {:keys [qpe-identity qpe-subscribe qpe-dispatch]}
                        {:keys [show container-ref]}]
  (let [metadata-configured @(qpe-subscribe [:qpe/data :ui :sidebar :metadata])]
    [layout/sidepanel
     {:show show
      :class "sidebar-md"
      :on-hide #(qpe-dispatch [:qpe/close-sidebar])
      :container container-ref}
     [layout/sidebar-header
      {:on-close #(qpe-dispatch [:qpe/close-sidebar])
       :title (:name initial-metadata)}]

     [layout/sidebar-content
      [:form
       {:on-submit (fn [e]
                     (.preventDefault e)
                     (qpe-dispatch [:metadata/save-metadata metadata-configured]))}

       [:div.form-group
        [form/form-label "QPE identity"]
        [form/form-control
         {:disabled true
          :value qpe-identity}]]

       [:div.form-group
        [form/form-label "Name"]
        [form/form-control
         {:on-change #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar :metadata :name] (.. % -target -value)])
          :value (or (:name metadata-configured)
                     (:name initial-metadata))}]]

       [:div.form-group
        [form/form-label "Location"]
        [form/form-control
         {:on-change #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar :metadata :location] (.. % -target -value)])
          :value (or (:location metadata-configured)
                     (:location initial-metadata))}]]

       [:div.form-group
        [form/form-label "Notes"]
        [form/form-control
         {:on-change #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar :metadata :notes] (.. % -target -value)])
          :value (or (:notes metadata-configured)
                     (:notes initial-metadata))}]]

       [:div.d-flex.flex-row.mx-n2.justify-content-end
        [:button.btn.btn-primary.mx-2.px-4
         {:type "submit"
          :disabled (not metadata-configured)}
         "Save"]]]]]))

(defn view [{:keys [status] :as qpe} {:keys [_qpe-subscribe qpe-dispatch]} owner-or-admin?]
  [:div.card.bg-gray-30.p-2.pl-3.flex-shrink-1
   [:div.d-flex.align-items-center.mb-1
    [:h5.py-2.my-0.flex-grow-1 "Metadata"]
    (when owner-or-admin?
      [dropdown/dropdown
       [dropdown/menu-icon-toggle]
       [dropdown/menu
        [dropdown/item
         {:on-click #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar] {:type :metadata}])
          :disabled (not= "online" status)}
         "Edit metadata"]]])]

   [:dl.m-0
    [:dt "Name"]
    [:dd (:name qpe)]

    [:dt "Location"]
    [:dd (:location qpe)]

    [:dt "Notes"]
    [:dd (:notes qpe)]]])
